import { Injectable, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, skip } from 'rxjs/operators';
import { OfflineStorageService } from 'src/app/services/offline/offline-storage.service';
import { FrontEventLogService } from './front-event-log.service';

@Injectable({ providedIn: 'root' })
export class ConnectivityLogService implements OnDestroy {
  private sub: Subscription | null = null;
  private started = false;

  constructor(
    private readonly offlineStorage: OfflineStorageService,
    private readonly frontEventLog: FrontEventLogService
  ) {}

  init(): void {
    if (this.started) {
      return;
    }
    this.started = true;

    this.sub = this.offlineStorage.online$
      .pipe(
        skip(1),
        debounceTime(2_000),
        distinctUntilChanged()
      )
      .subscribe((online) => {
        if (online) {
          this.frontEventLog.emitCatalog('conectividad', 'online');
        } else {
          this.frontEventLog.emitCatalog('conectividad', 'offline');
        }
      });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
